import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  padding-top: 0.7rem;
  cursor: pointer;
  display: none;

  @media ${(props) => props.theme.breakpoints.tablet} {
    display: block;
    right: 22px;
    top: -3px;
  }

  & span {
    background: #000000;
    display: block;
    position: relative;
    border-radius: 200px;
    width: 21px;
    height: 3px;
    margin-bottom: 4px;
    transition: all ease-in-out 0.2s;
  }

  &:hover {
    & span {
      background: ${({ theme }) => theme.colors.active1};
    }
  }
`

export default Wrapper
